import _get from 'lodash/get';
import { compile } from 'path-to-regexp';
import type { Get } from 'type-fest';

import type { EntityActionParams } from '@models';

/**
 * Uses `path-to-regexp` to compile a path-like state key with parameter values.
 * This can then be used to locate a nested state object.
 */
export const compileStateKey = <Params extends EntityActionParams | void>(
  stateKey: string,
  params: Params,
  delimiter = '/',
) => compile(stateKey, { delimiter })((params as Record<string, string>) ?? {});

/**
 * Returns the nested state object defined by a path-like string. If the path
 * is falsy or has a falsy result when walked, the original state is returned.
 * Accepts dot- or slash-delimited paths, which may optionally be parameterized.
 */
export const walkToState = <State, Path extends string>(
  state: State,
  pathToState: Path,
  params?: EntityActionParams,
): Get<State, Path> =>
  _get(
    state,
    compileStateKey(pathToState.replace('/', '.'), params, '.'),
    state,
  ) as Get<State, Path>;
